function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  const isBigScreen = window.innerWidth > 990;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (isBigScreen && canHover && summary.classList.contains('header__menu-item')) {
    summary.addEventListener('mouseover', (event) => {
      event.currentTarget.closest('details').setAttribute('open', true);
      event.currentTarget.setAttribute('aria-expanded', true);
    });
    summary.addEventListener('mouseout', (event) => {
      const details = summary.closest('details');
      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
        details.setAttribute('aria-expanded', false);
      });
    });
  }

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      if (buttonMinus != null) {
        buttonMinus.classList.toggle('disabled', value <= min);
      }
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VerticalSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));

    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    if (this.isMobile()) {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft; // Horizontal
      this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    } else {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop; // Vertical
      this.slidesPerPage = Math.floor(this.slider.clientHeight / this.sliderItemOffset);
    }
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    if (this.isMobile()) {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    } else {
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      (this.isMobile() ? this.slider.scrollLeft === 0 : this.slider.scrollTop === 0)
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    if (this.isMobile()) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft
      );
    } else {
      const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
      return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    if (this.isMobile()) {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.setSlidePosition(this.slideScrollPosition);
    } else {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollTop + step * this.sliderItemOffset
          : this.slider.scrollTop - step * this.sliderItemOffset;
      this.setSlidePositionTop(this.slideScrollPosition);
    }
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }

  setSlidePositionTop(position) {
    this.slider.scrollTo({
      top: position,
    });
  }
}

customElements.define('vertical-slider-component', VerticalSliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateTbEdBox();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateCollapsibles();
      this.updateInfoParaExportarPDF();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateCollapsibles() {
    const requestedVariantId = this.currentVariant.id;
    // Realizar la solicitud fetch para obtener el nuevo contenido
    const sectionId = document.getElementById('ProductCollapsibles').getAttribute('data-section-id');
    if (sectionId) {
      fetch(`${this.dataset.url}/?&variant=${requestedVariantId}&section_id=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          if (this.currentVariant.id !== requestedVariantId) return;
          var botonExportar = document.querySelector('#contenedor-boton-exportador > button');
          var reviewInfo = document.querySelector('#upng_review-info > #skeepers_product_widget');
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          document.getElementById('ProductCollapsibles').innerHTML =
            html.querySelector('#ProductCollapsibles').innerHTML;
          updateCollapsiblesReadMore();
          if (botonExportar) {
              var nuevoContenedor = document.getElementById('contenedor-boton-exportador');
              nuevoContenedor.appendChild(botonExportar);
          }
          if (reviewInfo) {
            var nuevoContenedorReview = document.getElementById('upng_review-info');
            nuevoContenedorReview.appendChild(reviewInfo);
          }
          this.tbUpdateFAQs(); //Thebath products FAQs form
        });
    }
  }

  updateInfoParaExportarPDF() {
    //Para que el PDF sepa cual es la variante actual
    const requestedVariantId = this.currentVariant.id;
    producto_info.id_variante_seleccionada = requestedVariantId;
  }

  updateMedia() {

    if (!this.currentVariant) return; 

    const variant_sku = this.currentVariant.sku;
    console.log('variant_sku: '+variant_sku);
    // Seleccionamos todos los elementos <li> con la clase "product__media-item upng-metafield-variant-image"
    const metafieldMediaItems = document.querySelectorAll("media-gallery .upng-metafield-variant-image");
    
    let first = true;
    var additional_media_id = "";
    metafieldMediaItems.forEach(item => {
        const dataValue = item.getAttribute("data");

        if (dataValue === variant_sku) {
          if(first){
            additional_media_id = item.getAttribute("data-upng-media-id");
            first = false;
          }
            item.classList.add("d-block");
            item.classList.remove("d-none");
        } else {
            item.classList.add("d-none");
            item.classList.remove("d-block");
        }
    });

    if (!this.currentVariant.featured_media){
      if(additional_media_id){
        const mediaGalleriesUpng = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
        mediaGalleriesUpng.forEach((mediaGallery) =>
          mediaGallery.setActiveMedia(`${this.dataset.section}-${additional_media_id}`, true)
        );
      }
      return;
    }
    // if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const checkedColor = this.querySelector('.swatch-button:checked');
    const selectedValue = checkedColor 
      ? checkedColor.value 
      : this.querySelector(':checked').value;

    const selectedOptionOneVariants = this.variantData.filter((variant) => {
      return [variant.option1, variant.option2, variant.option3].some(option => option === selectedValue);
    });

    let inputWrappers = [...this.querySelectorAll('.product-form__input')].map((element, index) => ({
      element: element,
      originalIndex: index + 1
    }));

    inputWrappers.sort((a, b) => {
      const aHasSwatch = a.element.querySelector('.swatch-button') ? 1 : 0;
      const bHasSwatch = b.element.querySelector('.swatch-button') ? 1 : 0;
      return bHasSwatch - aHasSwatch;
    });

    const indexMapping = {};
    inputWrappers.forEach((option, newIndex) => {
      indexMapping[newIndex + 1] = option.originalIndex; 
    });

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      const { element } = option;
      const optionInputs = [...element.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].element.querySelector(':checked')?.value;
      const originalIndex = indexMapping[index];

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && (variant.inventory_quantity > 0 || variant.metafields.permite_pedidos == true) && variant[`option${originalIndex}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${indexMapping[index + 1]}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  updateTbEdBox() {
  const container = document.getElementById('tb-ed-box-wrapper');
  if (!container) return;

  if (!this.currentVariant) return;

  const requestedVariantId = this.currentVariant.id;
  const sectionId = container.getAttribute('data-section-id');
  if (!sectionId) return;

  // Pedimos SOLO el section (como haces en renderProductInfo)
  fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`)
    .then((r) => r.text())
    .then((responseText) => {
      if (!this.currentVariant || this.currentVariant.id !== requestedVariantId) return;

      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const newBox = html.getElementById('tb-ed-box-wrapper');
      if (newBox) {
        container.innerHTML = newBox.innerHTML;
      }
    })
    .catch((e) => console.error('updateTbEdBox error:', e));
}

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;


    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);

        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const inventorySource2 = html.getElementById(
          `Inventory2-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination2 = document.getElementById(`Inventory2-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const titleSource = html.getElementById(
          `Title-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const titleDestination = document.getElementById(`Title-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (inventorySource2 && inventoryDestination2) inventoryDestination2.innerHTML = inventorySource2.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (titleSource && titleDestination) {
          titleDestination.innerHTML = titleSource.innerHTML;
          titleDestination.classList.toggle('hidden', titleSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');
        if (inventoryDestination2) inventoryDestination2.classList.toggle('hidden', inventorySource2.innerText === '');

        if (titleDestination) titleDestination.classList.toggle('hidden', titleSource.innerText === '');

        const mobileStickySource = html.getElementById(`product__mobile-sticky-${sectionId}`);
        const mobileStickyDestination = document.getElementById(`product__mobile-sticky-${sectionId}`);
        if (mobileStickySource && mobileStickyDestination) {
          mobileStickyDestination.innerHTML = mobileStickySource.innerHTML;
        }

        const devoluciconesmobileStickySource = html.getElementById(`upng-metafield-devoluciones-${sectionId}`);
        const devoluciconesmobileStickyDestination = document.getElementById(`upng-metafield-devoluciones-${sectionId}`);
        if (devoluciconesmobileStickySource && devoluciconesmobileStickyDestination) {
          devoluciconesmobileStickyDestination.innerHTML = devoluciconesmobileStickySource.innerHTML;
        }
        const addButtonSource = html.getElementById(`product-form__buttons-${sectionId}`);
        const addButtonDestination = document.getElementById(`product-form__buttons-${sectionId}`);
        if (addButtonSource && addButtonDestination) {
          addButtonDestination.innerHTML = addButtonSource.innerHTML;
        }
        // const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        // this.toggleAddButton(
        //   addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
        //   window.variantStrings.soldOut
        // );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.classList.add('disabled');
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.classList.remove('disabled');
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const inventory2 = document.getElementById(`Inventory2-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const title = document.getElementById(`Title-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (inventory2) inventory2.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (title) title.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  tbUpdateFAQs() {
    tbInitializedProductsFaqsForm(); //Thebath products FAQs form
  }  
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {

    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class VariantTheBath extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    // Vamos a revisar tanto selects como radio buttons
    listOfOptions.forEach((input) => {
      if (input.tagName === 'OPTION') {
        // Si es un select option
        // input.disabled = !listOfAvailableOptions.includes(input.value);
        if (listOfAvailableOptions.includes(input.value)) {
          input.innerHTML = input.value;  // Se limpia el valor si no es válido
          input.disabled = false; // Se habilita el input
        } else {
          input.innerHTML = translations.unavailable.replace("__OPTION__", input.value); // Se pone "unavailable" si está en la lista
          input.disabled = true; // Se deshabilita el input
        }
      } else if (input.type === 'radio') {
        // Si es un radio button
        if (listOfAvailableOptions.includes(input.value)) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      }
    });
  }

  updateOptions() {
    // Obtener selects y radio buttons
    const elementos = document.querySelectorAll(".upng_variant-picker");

    // Obtener los valores seleccionados en selects y radio buttons
    const valores = Array.from(elementos).map((elemento) => {
      if (elemento.tagName === "SELECT") {
        return elemento.value; 
      } else if (elemento.tagName === "FIELDSET") {
        const checkedRadio = Array.from(elemento.querySelectorAll('input')).find((radio) => radio.checked);
        return checkedRadio.value; 
      } 
    })
    this.options = valores;

  }
}

customElements.define('variant-thebath', VariantTheBath);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/* JS Upango */

function showLoading(button, show) {
  var loadingElement = button.querySelector('.loading-overlay__spinner');
  if (show) {
    button.setAttribute('aria-disabled', true);
    button.classList.add('loading');
    if (loadingElement != null) {
      loadingElement.classList.remove('hidden');
    }
  } else {
    button.removeAttribute('aria-disabled');
    button.classList.remove('loading');
    if (loadingElement != null) {
      loadingElement.classList.add('hidden');
    }
  }
}

function showErrorMessages(parentElement, messages) {
  showMessages(parentElement, messages, 'error');
}

function showInfoMessages(parentElement, messages) {
  showMessages(parentElement, messages, 'info');
}

function showWaningMessages(parentElement, messages) {
  showMessages(parentElement, messages, 'warning');
}

//type: error|info|warning
function showMessages(parentElement, messages, type) {
  var divErrors = parentElement.querySelector('.upng-messages');

  var alertClasses = 'upng-messages alert';
  if (type == 'error') {
    alertClasses += ' alert-danger';
  } else if (type == 'warning') {
    alertClasses += ' alert-warning';
  } else if (type == 'info') {
    alertClasses += ' alert-info';
  }

  if (divErrors) {
    divErrors.innerHTML = '';
    divErrors.style.display = 'flex';
  } else {
    // Crear un div para contener los mensajes de error
    divErrors = document.createElement('div');
  }
  divErrors.className = alertClasses;

  // Crear una lista para mostrar los mensajes de error
  const errorsList = document.createElement('ul');

  // Agregar cada mensaje de error a la lista
  messages.forEach((mensage) => {
    const liElement = document.createElement('li');
    liElement.textContent = mensage;
    errorsList.appendChild(liElement);
  });

  // Crear un botón para cerrar los mensajes
  const closeButton = document.createElement('button');
  closeButton.textContent = 'X';
  closeButton.setAttribute('type', 'button');
  closeButton.className = 'upng-messages-close close';
  closeButton.addEventListener('click', () => {
    divErrors.style.display = 'none';
  });

  // Agregar la lista de errores y el botón al div de errores
  divErrors.appendChild(closeButton);
  divErrors.appendChild(errorsList);

  // Agregar el div de errores como primer hijo del elemento padre
  if (parentElement.firstChild) {
    parentElement.insertBefore(divErrors, parentElement.firstChild);
  } else {
    parentElement.appendChild(divErrors);
  }
}

//Comprobar si se ha enviado un formulario para mostrar feedback
const searchParams = new URLSearchParams(window.location.search);
if (searchParams.has('contact_posted')) {
  document.getElementById('send-form-feedback').classList.remove('hidden');
}

//Hover en los productos de las colecciones
const productCardWrappers = document.querySelectorAll('.product-card-wrapper');

function handleMouseEnter() {
  const upngHoverDiv = this.querySelector('.upng-hover');
  if (upngHoverDiv) {
    upngHoverDiv.classList.remove('upng-hover-display-none');
    upngHoverDiv.classList.add('upng-hover-display-flex');
  }
}

// Función para manejar el evento cuando el ratón sale del div con clase "product-card-wrapper"
function handleMouseLeave() {
  // Encuentra el div con clase "upng-hover" dentro de este "product-card-wrapper"
  const upngHoverDiv = this.querySelector('.upng-hover');
  // Cambia el estilo "display" a "none" si se encuentra el div con clase "upng-hover"
  if (upngHoverDiv) {
    upngHoverDiv.classList.remove('upng-hover-display-flex');
    upngHoverDiv.classList.add('upng-hover-display-none');
  }
}

// Agrega manejadores de eventos a los elementos con clase "product-card-wrapper"
productCardWrappers.forEach((wrapper) => {
  wrapper.addEventListener('mouseenter', handleMouseEnter);
  wrapper.addEventListener('mouseleave', handleMouseLeave);
});

updateAndRenderCart = (productsMap, callbackFunction) => {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  let sections;
  if (cart != null) {
    sections = cart.getSectionsToRender().map((section) => section.id);
  } else {
    sections = 'cart-icon-bubble';
  }
  const updatesItems = Object.fromEntries(productsMap);
  //let items = Array.from(productsMap, ([id, quantity]) => ({ id, quantity }));

  const addToBasketData = { updates: updatesItems, sections: sections };
  //const updates = Object.fromEntries(productsMap);
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(addToBasketData), //JSON.stringify({ updates }),
  })
    .then((response) => response.json())
    .then((response) => {
      if (cart != null) {
        cart.renderContents(response);
      } else {
        // Actualizar las secciones correspondientes con el HTML recibido
        for (var section in response.sections) {
          if (response.sections.hasOwnProperty(section)) {
            var sectionNewContent = response.sections[section];
            var sectionCurrentElement = document.getElementById('cart-icon-bubble');
            if (sectionCurrentElement) {
              sectionCurrentElement.innerHTML = sectionNewContent;
            }
          }
        }
      }
      if (callbackFunction != null) callbackFunction();
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};
function updateCollapsiblesReadMore() {
  const paragraphs = document.querySelectorAll('.content__read_more');
  paragraphs.forEach((paragraph, index) => {
    const buttonId = paragraph.getAttribute('aria-labelledby');
    const button = document.querySelector(`[aria-controls="${buttonId}"] .button_read_more`);
    if (!button) return;
    const textSpan = button.querySelector('.text_read_more');
    const maxHeight = parseFloat(getComputedStyle(paragraph).maxHeight);
    let shouldShowButton = false;
    if (paragraph.classList.contains('upng_review-info')) {
      shouldShowButton = true;
    }else{
      shouldShowButton = paragraph.scrollHeight > maxHeight + 16;
    }
    if (shouldShowButton) {
      button.classList.add('show');
    } else {
      paragraph.classList.add('expanded');
    }
    button.addEventListener('click', function () {
      paragraph.classList.toggle('expanded');
      this.classList.toggle('expanded');
      this.classList.contains('expanded')
        ? (textSpan.textContent = this.getAttribute('data-label-minus'))
        : (textSpan.textContent = this.getAttribute('data-label-more'));
    });
  });
}

//Impedir que apps de terceros habiliten los botones de agregar al carrito cuando la casuística sea no disponible
document.addEventListener("DOMContentLoaded", function () {
  function protegerBoton(btn) {
      if (!btn) return;

      // Bloquea modificaciones directas a la propiedad disabled
      Object.defineProperty(btn, "disabled", {
          set: function(value) {
              if (this.classList.contains("estado_boton_no_disponible")) {
                  console.warn("Modificación bloqueada: el botón no se puede habilitar.", this);
                  return; // Bloqueamos el cambio si tiene la clase "estado_boton_no_disponible"
              }
              Object.getOwnPropertyDescriptor(HTMLButtonElement.prototype, "disabled").set.call(this, value);
          }
      });

      const originalSetAttribute = btn.setAttribute;
      btn.setAttribute = function(name, value) {
          if (name === "disabled" && this.classList.contains("estado_boton_no_disponible") && value !== "true") {
              console.warn("Intento de quitar disabled bloqueado en:", this);
              return;
          }
          originalSetAttribute.call(this, name, value);
      };

      const originalRemoveAttribute = btn.removeAttribute;
      btn.removeAttribute = function(name) {
          if (name === "disabled" && this.classList.contains("estado_boton_no_disponible")) {
              console.warn("Intento de eliminar disabled bloqueado en:", this);
              return;
          }
          originalRemoveAttribute.call(this, name);
      };
  }

  // Aplica la protección a todos los botones iniciales
  document.querySelectorAll(".product-form__submit").forEach(protegerBoton);

  // Observa cambios en el DOM para aplicar la protección a nuevos botones que se agreguen dinámicamente
  const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1 && node.matches(".product-form__submit")) {
                  protegerBoton(node);
              }
              if (node.nodeType === 1) {
                  node.querySelectorAll(".product-form__submit").forEach(protegerBoton);
              }
          });
      });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
  const elementSelectorVariant = document.querySelector('.swatch-button') || document.querySelector('.select__select.upng_variant-picker');
  if (!elementSelectorVariant) return;
  const reviewWrapper = document.querySelector('#upng_review-info');
  if (reviewWrapper){
    const observerReview = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1 && node.matches("#skeepers_product_widget")){
                elementSelectorVariant.dispatchEvent(new Event('change', { bubbles: true }));
                observerReview.disconnect();
              }
          });
            mutation.removedNodes.forEach(node => {
            if (node.nodeType === 1 && node.matches("#upng_review-info")) {
                elementSelectorVariant.dispatchEvent(new Event('change', { bubbles: true }));
                observerReview.disconnect();
            }
        });
      });
    });
    observerReview.observe(document.body, { childList: true, subtree: true });
  }else{
    elementSelectorVariant.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

/* SELECT COLOR DE LA FICHA DE PRODUCTO */
document.addEventListener("DOMContentLoaded", function () {
  function updateDisabledInputs() {
      document.querySelectorAll("fieldset.upng_variant-picker .upng-variant input.swatch-button").forEach(function (input) {
          if (input.classList.contains("disabled")) {
              if (!input.hasAttribute("disabled")) {
                  input.setAttribute("disabled", "");
              }
          } else {
              if (input.hasAttribute("disabled")) {
                  input.removeAttribute("disabled");
              }
          }
      });
  }
  
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.mega-menu__list.page-width.mega-menu__list--condensed').forEach(ul => {
      // Buscar si hay un <li> que contenga un <div class="mega-menu__grandchild">
      let hasGrandchild = Array.from(ul.children).some(li => 
          li.querySelector('.mega-menu__grandchild')
      );

      // Si NO hay .mega-menu__grandchild dentro de un <li>, agregar la clase al .mega-menu__content correspondiente
      if (!hasGrandchild) {
          let megaMenuContent = ul.closest('.mega-menu__content.mega-menu--custom__content');
          if (megaMenuContent) {
              megaMenuContent.classList.add('upng-megamenu__size_small');
          }
      }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.mega-menu__list.page-width.mega-menu__list--condensed').forEach(ul => {
      // Buscar si hay un <li> que contenga un <div class="mega-menu__grandchild">
      let hasGrandchild = Array.from(ul.children).some(li => 
          li.querySelector('.mega-menu__grandchild')
      );

      // Si NO hay .mega-menu__grandchild dentro de un <li>, agregar la clase al .mega-menu__content correspondiente
      if (!hasGrandchild) {
          let megaMenuContent = ul.closest('.mega-menu__content.mega-menu--custom__content');
          if (megaMenuContent) {
              megaMenuContent.classList.add('upng-megamenu__size_small');
          }
      }
  });
});

/*JS THE BATH*/
/*PRODUCTS FAQs FORM*/
document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("product-page")) {
    tbInitializedProductsFaqsForm();
  }
});
function tbInitializedProductsFaqsForm() {
    var modal = document.getElementById("faqsFormModal");
    var btn = document.getElementById("openFaqsFormModal");
    var closeBtn = document.getElementById("closeFaqsFormModal");
    
    btn.onclick = function () {
      modal.style.display = "flex";
    };

    closeBtn.onclick = function () {
      modal.style.display = "none";
    };

    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
    var tb_faqs_from_submit = document.getElementById("tb_faqs_form_submit");

    tb_faqs_from_submit.onclick =  function () {tbSendProductsFaqsForm()};
}
function tbSendProductsFaqsForm() {
  var submitBtn = document.getElementById("tb_faqs_form_submit");
  submitBtn.disabled = true;
  if (!document.getElementById("faq_email").value || !document.getElementById("faq_nombre").value || !document.getElementById("faq_pregunta").value) {
    document.getElementById('faqsFormModalSuccess').style.display = 'none';
    document.getElementById('faqsFormModalError').style.display = 'none';
    document.getElementById('faqsFormModalChecks').style.display = 'none';
    document.getElementById('faqsFormModalFields').style.display = 'block';
    submitBtn.disabled = false;
    return;
  } else if (!document.getElementById("faq_terms").checked || !document.getElementById("faq_data-consent").checked) {
    document.getElementById('faqsFormModalSuccess').style.display = 'none';
    document.getElementById('faqsFormModalError').style.display = 'none';
    document.getElementById('faqsFormModalFields').style.display = 'none';
    document.getElementById('faqsFormModalChecks').style.display = 'block';
    submitBtn.disabled = false;
    return;
  } else {
    var formdata = new FormData();
    formdata.append("faq_email", document.getElementById("faq_email").value);
    formdata.append("faq_nombre", document.getElementById("faq_nombre").value);
    formdata.append("faq_pregunta", document.getElementById("faq_pregunta").value);
    formdata.append("faq_product_id",document.getElementById("faq_product_id").value);
    formdata.append("faq_shop", document.getElementById("faq_shop").value);    
    formdata.append("faq_idioma", document.getElementById("faq_idioma").value);
  
    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };
    
    fetch("https://tbf-cd446fc00dcd.herokuapp.com/api/products-faqs/faqs-process-form", requestOptions)
      .then(response => response.json())
      .then(result => {
          if(result.faq_saved){
            document.getElementById('faqsFormModalError').style.display = 'none';
            document.getElementById('faqsFormModalFields').style.display = 'none';
            document.getElementById('faqsFormModalChecks').style.display = 'none';
            document.getElementById('faqsFormModalSuccess').style.display = 'block';
          }else{
            document.getElementById('faqsFormModalSuccess').style.display = 'none';
            document.getElementById('faqsFormModalFields').style.display = 'none';
            document.getElementById('faqsFormModalChecks').style.display = 'none';
            document.getElementById('faqsFormModalError').style.display = 'block';
            submitBtn.disabled = false;
          }
      })
      .catch(error => {
        console.log('error', error);
        submitBtn.disabled = false;
      });
  }
}
